import React from 'react';
import './HomeInfo.css';

import imgCampo from '../assets/ordeñe.jpg';
import imgQueso from '../assets/elaboracion.jpg';
import imgMaduracion from '../assets/como_producimos.jpg';
const ComoProducimosInfo = () => {
  return (
    
    <div className="home-info-container">
      <div className="quienes-hero produccion-hero">
        <div>
        <h1>Cómo Producimos</h1>
        </div>
      </div>
      {/* BLOQUE 1: */}
      <section className="info-block">
        <div className="info-text">
          <h2>Ordeñe</h2>
          <div className="title-underline"></div>
          <p>
            Nuestra producción comienza en el campo, mucho antes de llegar a la sala de elaboración. Nuestras vacas se alimentan exclusivamente de las pasturas de alfalfa que nosotros mismos sembramos, cultivamos y cosechamos en nuestras tierras del Alto Valle de Río Negro.
          </p>
          <p>
            Para garantizar el bienestar de nuestros animales y cuidar la salud del suelo, implementamos un sistema de rotación cuidado a lo largo de nuestras 10 hectáreas. Este respeto absoluto por los tiempos de la naturaleza nos permite obtener todos los días una leche pura y de calidad superior.
          </p>
        </div>
        <div className="info-image">
          {/* Reemplazar con la foto real del mapa o del campo */}
          <img 
            src={imgCampo} 
            alt="Vacas pastando" 
            loading="lazy"
          />
        </div>
      </section>

      {/* BLOQUE 2:*/}
      {/* Agregamos la clase "reverse" para dar vuelta las columnas en PC */}
      <section className="info-block reverse">
        <div className="info-text">
          <h2>Elaboración</h2>
          <div className="title-underline"></div>
          <p>
            Nuestra línea de producción se distingue por ser 100% agroecológica. Transformamos nuestra leche recién ordeñada de manera totalmente natural, sin utilizar ningún tipo de aditivo artificial ni conservantes.
          </p>
          <p>
            Nos especializamos en la elaboración artesanal de queso estilo Gouda. Para ofrecer una experiencia gastronómica distinta en la región, innovamos nuestro proceso incorporando ingredientes naturales, creando variedades únicas saborizadas con pimienta en grano, ají, pesto, pimentón y nuestra exclusiva versión ahumada.
          </p>
            </div>
          <div className="info-image">
          <img 
            src={imgQueso} 
            alt="Queso elaborado" 
            loading="lazy"
          />
        </div>
      </section>

    
         {/* BLOQUE 3: */}
      <section className="info-block">
        <div className="info-text">
          <h2>Maduración</h2>
          <div className="title-underline"></div>
          <p>
             Cada queso descansa en nuestras instalaciones el tiempo exacto y necesario para desarrollar su textura firme, sus aromas y su sabor inconfundible.

          </p>
          <p>
            Durante este proceso de afinado, cuidamos cada detalle para que el producto alcance su punto máximo de expresión. El resultado final es un queso de calidad
            listo para viajar desde nuestro tambo directo a tu mesa.
          </p>
        </div>
        <div className="info-image">
          {/* Reemplazar con la foto real del mapa o del campo */}
          <img 
            src={imgMaduracion} 
            alt="Sala de maduración" 
            loading="lazy"
          />
        </div>
      </section>
    </div>
  );
};

export default ComoProducimosInfo;